import styled from 'styled-components'
import { Breakpoints } from '@volkswagen-onehub/components-core'

export const StyledSection = styled.div`
  @media (max-width: ${Breakpoints.tablet}px) {
    h2 {
      padding: 50px 0 0;
    }
  }
  @media (min-width: ${Breakpoints.b560}px) {
    h2 {
      padding-bottom: 0;
      font-size: ${props => props.theme.textAppearances.headline350.fontSize};
    }
  }
  @media (min-width: ${Breakpoints.tablet}px) {
    background-image: url(${props => props.imageSrc});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    margin-bottom: 32px;

    h3 {
      padding: 150px 0;
    }
  }

  @media (min-width: ${Breakpoints.b1280}px) {
    h3 {
      padding: 15vw 0;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .image-wrapper {
    max-height: 50vw;
    overflow: hidden;
  }
`
